// App.jsx
import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AuthProvider from './providers/Auth';

// Layouts
import AppLayout from './components/Template/Layout';
import AdminLayout from './components/Template/AdminLayout.jsx';

// Pages públicas/cliente
import Home from './components/Sections/Home';
import LoginPage from './components/Sections/Auth/login';
import Register from './components/Sections/Auth/Register';
import ConfirmAccount from './components/Sections/Auth/Register/confirmar-cuenta';
import ForgotPassword from './components/Sections/Auth/forgotPassword.js';
import Unauthorized from './components/Sections/Unauthorized.jsx';
import NotFound from './components/Sections/NotFound/index.js';

// Pages admin
import TalleresAdmin from './components/Sections/Admin/Talleres/index.js';
import CrearTaller from './components/Sections/Admin/Talleres/Create/index.js';
import TalleresEditar from './components/Sections/Admin/Talleres/Edit/TallerEditar.jsx';
import UsuariosList from './components/Sections/Admin/Usuarios/UsuariosList.jsx';
import UsuariosCrear from './components/Sections/Admin/Usuarios/Create/UsuariosCrear.jsx';

// 🆕 Pages admin - Matrículas
import ConfiguracionMatriculas from './components/Sections/Admin/Matriculas/Configuracion.jsx';
import UsuariosMatriculados from './components/Sections/Admin/Matriculas/UsuariosMatriculados.jsx';
import EstadisticasMatriculas from './components/Sections/Admin/Matriculas/Estadisticas.jsx';
import RegistroManual from './components/Sections/Admin/Matriculas/RegistroManual.jsx';
import CargaMasivaMatriculas from './components/Sections/Admin/Matriculas/CargaMasiva.jsx';
import FuncionariosMatricula from './components/Sections/Admin/Matriculas/Funcionarios.jsx';

// 🆕 Pages cliente - Matrículas
import ComprarMatricula from './components/Sections/Matriculas/ComprarMatricula.jsx';
import MisMatriculas from './components/Sections/Cliente/MisMatriculas/index.js';

// Guards
import {
  GuestRoute,
  RequireAprobador,
  RequireModulo,
  RequireSesion,
} from './routes/guards.js';
import AdminLanding from './routes/AdminLanding.jsx';

import RolesList from './components/Sections/Admin/Roles/index.jsx';
import RolForm from './components/Sections/Admin/Roles/RolForm.jsx';

import { NotificationProvider } from './providers/NotificationProvider.jsx';
import WaitingRoomGate from './components/WaitingRoom/WaitingRoomGate.jsx';
import { ConfigProvider, App as AppAntd } from 'antd';
import esEs from 'antd/locale/es_ES';
import CambiosRevisiones from './components/Sections/Admin/Talleres/CambiosRevisiones/index.js';
import HistorialCambios from './components/Sections/Admin/Talleres/History/index.js';
import CarritoCompras from './components/Sections/Carrito/index.js';
// v1 checkout eliminado: el flujo v2 (CheckoutV2) es el único.
import PerfilCliente from './components/Sections/Cliente/Perfil/index.jsx';
import MisInscripciones from './components/Sections/Cliente/MisTalleres/index.js';
import ListaRecintos from './components/Sections/Admin/Recintos/index.js';
import CrearRecinto from './components/Sections/Admin/Recintos/Create.js';
import DetalleRecinto from './components/Sections/Admin/Recintos/Detail.js';
import CodigosDescuentoTable from './components/Sections/Admin/CodigosDescuento/CodigosDescuentoTable.jsx';
import DescuentoAutomaticoForm from './components/Sections/Admin/CodigosDescuento/Create/index.jsx';
import CodigosManualesTable from './components/Sections/Admin/CodigosManuales/CodigosManualesTable.jsx';
import CodigoManualForm from './components/Sections/Admin/CodigosManuales/Create/index.jsx';
import WaitingRoomDashboard from './components/Sections/Admin/WaitingRoom/index.jsx';
import GestionFamiliares from './components/Sections/Cliente/Cargas/index.jsx';
import DescuentoAutomaticoDetalle from './components/Sections/Admin/CodigosDescuento/Detail/CodigoDescuentoDetalle.jsx';
import DetalleTaller from './components/Sections/Talleres/DetailTaller.jsx';
import TalleresHistorialCiclos from './components/Sections/Admin/Talleres/HistorialCiclos/index.js';
import { CartProvider } from './providers/Cart.jsx';
import Privacy from './components/Sections/privacy/index.js';
import VentasNueva from './components/Sections/Admin/Ventas/VentaNueva.jsx';
import DashboardReporteria from './components/Sections/Admin/Reporteria/DashboardReporteria.jsx';
import IngresosVentas from './components/Sections/Admin/Reporteria/IngresosVentas.jsx';
import Descuentos from './components/Sections/Admin/Reporteria/Descuentos.jsx';
import ReportesDemograficos from './components/Sections/Admin/Reporteria/reportesDemograficos.jsx';
import ComportamientoRetencion from './components/Sections/Admin/Reporteria/ComportamientoRetencion.jsx';
import VentasTalleres from './components/Sections/Admin/Reporteria/VentaTalleres.jsx';
import VentasUnificadas from './components/Sections/Admin/Reporteria/VentasUnificadas.jsx';
import AdminDashboard from './components/Sections/Admin/Dashboard/index.jsx';
import ComunicacionesLista from './components/Sections/Admin/Comunicaciones/ComunicacionesLista.jsx';
import ComunicacionNueva from './components/Sections/Admin/Comunicaciones/ComunicacionNueva.jsx';
import ComunicacionFicha from './components/Sections/Admin/Comunicaciones/ComunicacionFicha.jsx';
import BajaComunicaciones from './components/Sections/Baja/index.jsx';

// v2 (ahora el flujo principal): checkout, retorno Webpay y panel de revisión.
import CheckoutV2 from './components/Sections/Checkout/CheckoutV2';
import PagoReturnV2 from './components/Sections/Checkout/PagoReturnV2';
import Operaciones from './components/Sections/Admin/Operaciones/index.jsx';
import AgendaReservas from './components/Sections/Admin/Agenda/Reservas.jsx';
import AgendaServicios from './components/Sections/Admin/Agenda/Servicios.jsx';
import AgendaProfesionales from './components/Sections/Admin/Agenda/Profesionales.jsx';
import AgendaVentas from './components/Sections/Admin/Agenda/Ventas.jsx';
import PreviewTable from './components/Sections/Admin/Talleres/__PreviewTable.jsx'; // ⚠️ TEMPORAL


function App() {
  return (
    <ConfigProvider locale={esEs} theme={{ token: { colorPrimary: '#0047bb', colorLink: '#0047bb', borderRadius: 10 } }}>
      <AppAntd>
        <AuthProvider>
          <NotificationProvider>
            <CartProvider>
              <WaitingRoomGate>
              <BrowserRouter>
                <Routes>
                  {/* Ramas con AppLayout: públicas, guest, cliente, unauthorized y 404 */}
                  <Route element={<AppLayout />}>
                    {/* Públicas sin restricción */}
                    <Route path="/" element={<Home />} />
                    <Route path="/talleres/:id" element={<DetalleTaller />} />
                    <Route path="/unauthorized" element={<Unauthorized />} />
                    <Route path="/carrito" element={<CarritoCompras />} />
                    <Route path="/checkout" element={<CheckoutV2 />} />
                    {/* 🆕 v2: returns de Webpay (idempotentes) */}
                    <Route path="/v2/checkout/return" element={<PagoReturnV2 flujo="online" />} />
                    <Route path="/v2/venta-presencial/return" element={<PagoReturnV2 flujo="venta_presencial" />} />
                    <Route path="/privacy" element={<Privacy />} />
                    {/* Baja de los correos informativos (enlace firmado, sin sesión) */}
                    <Route path="/baja" element={<BajaComunicaciones />} />
                    {/* ⚠️ TEMPORAL preview de diseño — NO commitear */}
                    <Route path="/__preview/talleres" element={<PreviewTable />} />

                    {/* Solo invitados (usuarios no autenticados) */}
                    <Route element={<GuestRoute redirectTo="/perfil" />}>
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/registro" element={<Register />} />
                      <Route path="/confirmar-cuenta" element={<ConfirmAccount />} />
                      <Route path="/olvidar-contrasena" element={<ForgotPassword />} />
                    </Route>

                    {/* Cualquier persona con cuenta. Antes esto era una lista de roles, así
                        que un rol nuevo —`funcionario`, por ejemplo— no podía ni ver su
                        propio perfil ni sus talleres. */}
                    <Route element={<RequireSesion />}>
                      <Route path="/perfil" element={<PerfilCliente />} />
                      <Route path="/mis-talleres" element={<MisInscripciones />} />
                      <Route path="/familiares" element={<GestionFamiliares />} />

                      {/* 🆕 Matrículas - Cliente */}
                      <Route path="/matriculas/comprar" element={<ComprarMatricula />} />
                      <Route path="/mis-matriculas" element={<MisMatriculas />} />
                    </Route>

                    {/* 404 con AppLayout */}
                    <Route path="*" element={<NotFound />} />
                  </Route>

                  {/* ========================================
                      RUTAS ADMIN
                      Cada bloque declara el PERMISO que exige —(módulo, acción)— y no
                      una lista de roles. Así un rol creado desde el panel entra a lo
                      que le marcaron sin tocar este archivo, y el menú no puede
                      desalinearse de las rutas: los dos preguntan lo mismo.
                      ======================================== */}

                  {/* Puerta de entrada.
                      Va FUERA del permiso de 'dashboard' a propósito: quien no ve el
                      dashboard también tiene que poder entrar al panel y caer en su
                      primer módulo. AdminLanding deriva el destino del menú ya
                      filtrado, así que entrada y navegación no pueden discrepar. */}
                  <Route element={<RequireSesion />}>
                    <Route path="/admin" element={<AdminLanding />} />
                  </Route>

                  {/* Inicio */}
                  <Route element={<RequireModulo modulos="dashboard" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    </Route>
                  </Route>

                  {/* Talleres — consulta */}
                  <Route element={<RequireModulo modulos="talleres" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/talleres/lista" element={<TalleresAdmin />} />
                      <Route path="/admin/talleres/:tallerId/ciclos-historial" element={<TalleresHistorialCiclos />} />
                      <Route path="/admin/talleres/editar/:tallerId/historial-cambios" element={<HistorialCambios />} />
                    </Route>
                  </Route>

                  {/* Talleres — gestión. Quien tenga «requiere aprobación» igual entra:
                      lo que hace el backend con su cambio es encolarlo, no rechazarlo. */}
                  <Route element={<RequireModulo modulos="talleres" accion="editar" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/talleres/crear" element={<CrearTaller />} />
                      <Route path="/admin/talleres/editar/:tallerId" element={<TalleresEditar />} />
                    </Route>
                  </Route>

                  {/* Talleres — cola de revisión: la resuelve quien no necesita que le
                      aprueben a él. */}
                  <Route element={<RequireAprobador modulo="talleres" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/talleres/cambios-revisiones" element={<CambiosRevisiones />} />
                    </Route>
                  </Route>

                  {/* Usuarios */}
                  <Route element={<RequireModulo modulos="usuarios" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/usuarios" element={<UsuariosList />} />
                    </Route>
                  </Route>

                  <Route element={<RequireModulo modulos="usuarios" accion="editar" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/usuarios/crear" element={<UsuariosCrear />} />
                      <Route path="/admin/usuarios/editar/:userId" element={<div>Editar Usuario</div>} />
                    </Route>
                  </Route>

                  {/* Roles y permisos */}
                  <Route element={<RequireModulo modulos="roles" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/roles" element={<RolesList />} />
                      <Route path="/admin/roles/:key" element={<RolForm />} />
                    </Route>
                  </Route>

                  <Route element={<RequireModulo modulos="roles" accion="editar" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/roles/nuevo" element={<RolForm />} />
                    </Route>
                  </Route>

                  {/* Recintos */}
                  <Route element={<RequireModulo modulos="recintos" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/recintos" element={<ListaRecintos />} />
                      <Route path="/admin/recintos/:id" element={<DetalleRecinto />} />
                    </Route>
                  </Route>

                  <Route element={<RequireModulo modulos="recintos" accion="editar" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/recintos/crear" element={<CrearRecinto />} />
                      <Route path="/admin/recintos/:id/editar" element={<CrearRecinto />} />
                    </Route>
                  </Route>

                  {/* Descuentos */}
                  <Route element={<RequireModulo modulos="descuentos" />}>
                    <Route element={<AdminLayout />}>
                      <Route path='/admin/descuentos-automaticos' element={<CodigosDescuentoTable />} />
                      <Route path='/admin/descuentos-automaticos/:id' element={<DescuentoAutomaticoDetalle />} />
                      <Route path='/admin/codigos-manuales' element={<CodigosManualesTable />} />
                    </Route>
                  </Route>

                  <Route element={<RequireModulo modulos="descuentos" accion="editar" />}>
                    <Route element={<AdminLayout />}>
                      <Route path='/admin/descuentos-automaticos/crear' element={<DescuentoAutomaticoForm />} />
                      <Route path='/admin/descuentos-automaticos/editar/:id' element={<DescuentoAutomaticoForm />} />
                      <Route path='/admin/codigos-manuales/crear' element={<CodigoManualForm />} />
                      <Route path='/admin/codigos-manuales/editar/:id' element={<CodigoManualForm />} />
                    </Route>
                  </Route>

                  {/* Sala de espera */}
                  <Route element={<RequireModulo modulos="sala-espera" />}>
                    <Route element={<AdminLayout />}>
                      <Route path='/admin/waiting-room' element={<WaitingRoomDashboard />} />
                    </Route>
                  </Route>

                  {/* Operaciones — torniquete, casos y cuadre de caja.
                      Entra quien tenga cualquiera de los dos permisos; adentro solo ve
                      sus pestañas (ver Operaciones/index.jsx). Antes esta ruta exigía
                      admin o coordinador mientras el menú se la ofrecía al jefe de
                      recinto: el menú prometía una pantalla que la ruta negaba. */}
                  <Route element={<RequireModulo modulos={['torniquete', 'casos']} />}>
                    <Route element={<AdminLayout />}>
                      <Route path='/admin/operaciones' element={<Operaciones />} />
                    </Route>
                  </Route>

                  {/* Agendamiento de servicios. Todas las pantallas se VEN con `agenda:ver`;
                      los botones de crear/editar los decide `can(user, 'agenda', 'editar')`
                      adentro de cada una (y el backend vuelve a exigirlo). */}
                  <Route element={<RequireModulo modulos="agenda" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/agenda" element={<Navigate to="/admin/agenda/reservas" replace />} />
                      <Route path="/admin/agenda/reservas" element={<AgendaReservas />} />
                      <Route path="/admin/agenda/servicios" element={<AgendaServicios />} />
                      <Route path="/admin/agenda/profesionales" element={<AgendaProfesionales />} />
                      <Route path="/admin/agenda/ventas" element={<AgendaVentas />} />
                    </Route>
                  </Route>

                  {/* Matrículas */}
                  <Route element={<RequireModulo modulos="matriculas" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/matriculas" element={<Navigate to="/admin/matriculas/configuracion" replace />} />
                      <Route path="/admin/matriculas/usuarios" element={<UsuariosMatriculados />} />
                    </Route>
                  </Route>

                  <Route element={<RequireModulo modulos="matriculas" accion="editar" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/matriculas/configuracion" element={<ConfiguracionMatriculas />} />
                      <Route path="/admin/matriculas/estadisticas" element={<EstadisticasMatriculas />} />
                      <Route path="/admin/matriculas/manual" element={<RegistroManual />} />
                      <Route path="/admin/matriculas/carga-masiva" element={<CargaMasivaMatriculas />} />
                      <Route path="/admin/matriculas/funcionarios" element={<FuncionariosMatricula />} />
                    </Route>
                  </Route>

                  {/* Ventas */}
                  <Route element={<RequireModulo modulos="ventas" accion="editar" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/ventas/nueva" element={<VentasNueva />} />
                    </Route>
                  </Route>

                  {/* Comunicaciones (correos masivos) — consulta */}
                  <Route element={<RequireModulo modulos="comunicaciones" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/comunicaciones" element={<ComunicacionesLista />} />
                      <Route path="/admin/comunicaciones/:id" element={<ComunicacionFicha />} />
                    </Route>
                  </Route>

                  {/* Comunicaciones — redactar y enviar */}
                  <Route element={<RequireModulo modulos="comunicaciones" accion="editar" />}>
                    <Route element={<AdminLayout />}>
                      <Route path="/admin/comunicaciones/redactar" element={<ComunicacionNueva />} />
                      <Route path="/admin/comunicaciones/:id/editar" element={<ComunicacionNueva />} />
                    </Route>
                  </Route>

                  {/* Reportería */}
                  <Route element={<RequireModulo modulos="reporteria" />}>
                    <Route element={<AdminLayout />}>
                      {/* Dashboard General */}
                      <Route path="/admin/reporteria/dashboard" element={<DashboardReporteria />} />

                      {/* Reportes Financieros */}
                      <Route path="/admin/reporteria/financiero/ingresos" element={<IngresosVentas />} />
                      <Route path="/admin/reporteria/financiero/descuentos" element={<Descuentos />} />
                      <Route path="/admin/reporteria/ventas-unificadas" element={<VentasUnificadas />} />

                      {/* Reportes demográficos */}
                      <Route path="/admin/reporteria/usuarios/demografia" element={<ReportesDemograficos />} />
                      <Route path="/admin/reporteria/usuarios/comportamiento" element={<ComportamientoRetencion />} />

                      <Route
                        path="/admin/reporteria/ventas/talleres"
                        element={<VentasTalleres />}
                      />

                    </Route>
                  </Route>
                </Routes>
              </BrowserRouter>
              </WaitingRoomGate>
            </CartProvider>
          </NotificationProvider>
        </AuthProvider>
      </AppAntd>
    </ConfigProvider>
  );
}

export default App;
